import { createAsyncThunk } from '@reduxjs/toolkit';
import { DataMaintenanceApi } from '../../api/DataMaintenanceApi';

//Gets paginated Images data
export const getImages = createAsyncThunk(
  'images/getImages',
  async (
    action: { page: number; limit: number; searchCode?: string; materialCode?: string },
    thunkAPI
  ) => {
    action.materialCode = action.searchCode;
    return DataMaintenanceApi.getImages(action, thunkAPI.dispatch);
  }
);
